// 9fbef606107a605d69c0edbcd8029e5d
export const GLOBAL_LABELS = 'global';
export const STORE_LOCATOR_LABELS = 'StoreLocator';
export const BROWSE_LABELS = 'Browse';
export const ACCOUNT_LABELS = 'account';

// Action Labels
export const lblCreateAccount = `lbl_createAccount`;
export const lblLogin = `lbl_login`;
export const lblSaveCaps = `lbl_save_caps`;
export const lblHello = `lbl_Hello`;

// Accessibility Labels
export const skipNavigation = `skipNavigation`;
export const accountIconButton = `accountIconButton`;
export const closeIconButton = `closeIconButton`;
export const cartIconButton = `cartIconButton`;
export const favoriteIconButton = 'favoriteIconButton';
export const hamburgerMenu = `hamburgerMenu`;
export const lblBrandLogoTcpAltText = `lbl_brandlogo_tcpAltText`;
export const lblBrandLogoGymAltText = `lbl_brandlogo_gymAltText`;
export const lblBrandLogoSnjAltText = `lbl_brandlogo_snjAltText`;
export const lblBrandLogoPjpAltText = `lbl_brandlogo_pjpAltText`;

// Account Drawer Label
export const lblStaticRewardSignInOrCreate = `lbl_staticReward_signInOrCreate`;

// Country Selector
export const lblGlobalCountrySelectorHeader = `lbl_global_country_selector_header`;
export const lblGlobalCountrySelectorSubHeader = `lbl_global_country_selector_subheader`;
export const lblGlobalCountry = `lbl_global_country`;
export const lblGlobalLanguage = `lbl_global_language`;
export const lblGlobalCurrency = `lbl_global_currency`;

// Header Label
export const lblShopThisStoreNotificationMessage = `lbl_shopThisStore_notificationMessage`;
export const lblShopThisStoreStoreChange = `lbl_shopThisStore_storeChange`;
export const lblShopThisStoreShopOnline = `lbl_shopThisStore_shopOnline`;
export const lblShopThisStoreSearch = `lbl_shopThisStore_search`;
export const lblShopThisStoreShopAt = `lbl_shopThisStore_shopAt`;

// Track Order
export const lblFindOrderOrders = `lbl_findOrder_orders`;
export const lblTrackOrderHeader = `lbl_trackOrder_header`;

// Search
export const lblSearchRecentSearch = `lbl_search_recent_search`;

// Store Landing Labels
export const lblStoreLandingOpensAt = `lbl_storelanding_opensAt`;
export const lblStoreLandingOpenInterval = `lbl_storelanding_openInterval`;
export const lblStoreLandingFindStoreHeading = `lbl_storelanding_findStoreHeading`;

// Store Details Labels
export const lblStoreDetailsClosed = `lbl_storeldetails_closed`;
export const lblStoreDetailsShopThisStore = `lbl_storedetails_shopThisStore`;
export const lblStoreDetailsSelectDifferentStore = `lbl_storedetails_selectDifferentStore`;
export const lblStoreDetailSelectStoreBtn = `lbl_storedetail_selectstore_btn`;

// Product Pickup Labels
export const lblProductPickupSelectedStore = `lbl_Product_pickup_SELECTED_STORE`;

// Account Overview Labels
export const lblOverviewMyStore = `lbl_overview_myStore`;
export const lblOverviewHeaderMyFavorite = `lbl_overview_headerMyFavorite`;

// Account Benefits
export const lblBenefitEarnRewardDescription = 'lbl_benefit_earn_rewards_description';
export const lblBenefitEarnRewardTitle = 'lbl_benefit_earn_rewards_title';
export const lblBenefitGiftsDescription = 'lbl_benefit_gifts_description';
export const lblBenefitGiftsTitle = 'lbl_benefit_gifts_title';
export const lblBenefitSpecialOffersTitle = 'lbl_benefit_special_offers_title';
export const lblBenefitSpecialOffersDescription = 'lbl_benefit_special_offers_description';

const HeaderLabels = {
  global: {
    actions: {
      [lblCreateAccount]: 'Create Account',
      [lblLogin]: 'Log In',
      [lblSaveCaps]: 'SAVE',
      [lblHello]: 'Hello!',
    },
    accessibility: {
      [skipNavigation]: 'skip to main content',
      [accountIconButton]: 'account',
      [closeIconButton]: 'close',
      [cartIconButton]: 'cart',
      [favoriteIconButton]: 'Favorite',
      [hamburgerMenu]: 'hamburger menu',
      [lblBrandLogoTcpAltText]: `The Children's Place logo | Click to visit The Children's Place Website`,
      [lblBrandLogoGymAltText]: 'Gymboree logo | Click to visit Gymboree Website',
      [lblBrandLogoSnjAltText]: 'Sugar and Jade logo | Click to visit Sugar and Jade Website',
      [lblBrandLogoPjpAltText]: 'PJ Place logo | Click to visit PJ Place Website',
    },
    accountDrawer: {
      [lblStaticRewardSignInOrCreate]:
        'Log in or create an account to earn points on every purchase, every brand!',
    },
    countrySelector: {
      [lblGlobalCountry]: 'Country',
      [lblGlobalLanguage]: 'Language',
      [lblGlobalCurrency]: 'Currency',
      [lblGlobalCountrySelectorHeader]: 'Ship To',
      [lblGlobalCountrySelectorSubHeader]: 'Change Shipping Preference',
    },
    header: {
      [lblShopThisStoreNotificationMessage]: 'You are no longer shopping products from',
      [lblShopThisStoreStoreChange]: 'Change Store',
      [lblShopThisStoreShopOnline]: 'Switch to Online',
      [lblShopThisStoreSearch]: 'Search items at this location',
      [lblShopThisStoreShopAt]: 'Shopping at',
    },
    trackOrder: {
      [lblFindOrderOrders]: 'Orders',
      [lblTrackOrderHeader]: 'Track Order',
    },
    Search: {
      [lblSearchRecentSearch]: 'YOUR RECENT SEARCHES',
    },
    tierBenefits: {
      [lblBenefitEarnRewardDescription]: '100 points = $5',
      [lblBenefitEarnRewardTitle]: 'Earn Rewards',
      [lblBenefitGiftsDescription]: 'Exclusive in-store gifts for special moments',
      [lblBenefitGiftsTitle]: 'Member-Only Gifts',
      [lblBenefitSpecialOffersTitle]: 'Special Offers',
      [lblBenefitSpecialOffersDescription]: 'Unlock VIP events and early offers',
    },
  },

  StoreLocator: {
    StoreLanding: {
      [lblStoreLandingOpensAt]: 'opens at',
      [lblStoreLandingOpenInterval]: 'Open until',
      [lblStoreLandingFindStoreHeading]: 'Find a Store',
      [lblStoreDetailSelectStoreBtn]: 'Select Store',
    },
    StoreDetail: {
      [lblStoreDetailsClosed]: 'Closed',
      [lblStoreDetailsShopThisStore]: 'Shop This Store',
      [lblStoreDetailsSelectDifferentStore]: 'Select a Different Store',
    },
  },

  Browse: {
    ProductPickup: {
      [lblProductPickupSelectedStore]: 'Selected Store',
    },
  },

  account: {
    accountOverview: {
      [lblOverviewMyStore]: 'My Store',
      [lblOverviewHeaderMyFavorite]: 'My Favorite',
    },
  },
};

export default HeaderLabels;
